// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon_icon___L1OO","animate":"icon_animate__sE_7L","spin":"icon_spin__1OJBH"};